import type { GrowthBook } from '@growthbook/growthbook'
import firebase from 'firebase/compat/app'
import {
  Cohort,
  CurrentEnvironment,
  EventLoggerInstanceName,
} from 'root-constants'
import { Amplitude } from 'services/amplitude.service'
import { eventLogger } from 'services/eventLogger.service'
import { getFrcEventProps } from './getFrcEventProps'
import { getAbTestOptions } from './getAbTestOptions'
import { getAbTestVariantData } from './getAbTestVariantData'
import { getRemoteConfigVariantData } from './getRemoteConfigVariantData'
import {
  COHORT_FIREBASE_KEYS_MAP,
  COHORT_GROWTHBOOK_KEYS_MAP,
} from 'constants/ab-tests'
import { getGrowthbookVariantData } from './getGrowthbookVariantData'

export const addAmplitudeLogger = ({
  amplitudeApiKey,
  uuid,
  utmTags,
  cohort,
  firebaseRemoteConfig,
  growthbook,
  country,
}: {
  amplitudeApiKey: string
  uuid: string
  utmTags: Record<string, string>
  cohort: Cohort
  firebaseRemoteConfig: firebase.remoteConfig.RemoteConfig | null
  growthbook?: GrowthBook | null
  country: string
}): void => {
  const isProdEnvironment =
    import.meta.env.CURRENT_ENV === CurrentEnvironment.PROD

  const amplitudeService = new Amplitude({
    apiKey: amplitudeApiKey,
    instanceName: EventLoggerInstanceName.AMPLITUDE,
    userId: uuid,
    utmTags: {
      ...utmTags,
      uuid,
    },
    isProdEnvironment,
  })

  const remoteConfigVariantValue = getAbTestVariantData({
    firebaseRemoteConfigVariantData: getRemoteConfigVariantData({
      firebaseRemoteConfig,
      firebaseRemoteConfigKey: COHORT_FIREBASE_KEYS_MAP[cohort],
    }),
    growthbookVariantData: getGrowthbookVariantData({
      growthbook: growthbook || null,
      growthbookKey: COHORT_GROWTHBOOK_KEYS_MAP[cohort],
    }),
    cohort,
    country,
  })

  const intellioAbTestOptions = getAbTestOptions({
    cohort,
    remoteConfigVariantValue,
    country,
  })

  amplitudeService.configure({
    cohort,
    options: {
      ...(intellioAbTestOptions || {}),
      ...getFrcEventProps(),
    },
  })
  eventLogger.addLoggers([amplitudeService])
}
